import request from '@/utils/request'

let upload = (data) => request.post('/api/setPackageImei/upload', data, { 'content-type': 'multipart/form-data' })

export default {
  upload
}